export default __webpack_public_path__ + "static/media/antelope-4-thumbnail.ce1cafba.jpg";